import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { FirebaseService } from '../../services/firebase.service';

import { Observable } from 'rxjs/Observable';

import { List } from '../../models/list';
import { Recipe } from '../../models/recipe';

@Component({
	selector    : 'manage-lists-recipes',
	templateUrl : 'manage-lists-recipes.html',
	styleUrls   : [ 'manage-lists-recipes.scss' ]
})

export class ManageListsRecipesComponent {
  isList            : boolean;
  itemName          : string;
  titleCaseItemName : string;

  items     : Observable<List[] | Recipe[]>;
  sortBy    : string;
  ascending : boolean = true;

  sharedLists     : Observable<any>;
  sharedSortBy    : string;
  sharedAscending : boolean = true;

  constructor(
    private firebaseService : FirebaseService,
    private route           : ActivatedRoute
  ) {
    this.isList = this.route.toString() === 'Route(url:\'lists\', path:\'lists\')';

    this.itemName          = this.isList ? 'list' : 'recipe';
    this.titleCaseItemName = this.isList ? 'List' : 'Recipe';

    this.initItems();

    if (this.isList)
      this.initSharedLists();
  }

  initItems(counter : number = 0) : void {
    if (this.firebaseService[`${this.itemName}s`]) {
      this.sort('createdAt'); // default sort is createdAt
    } else if (counter++ < 100) {
      setTimeout(() => this.initItems(counter), 10);
    }
  }

  initSharedLists(counter : number = 0) : void {
    if (this.firebaseService.sharedLists) {
      this.sharedSort('createdAt'); // default sort is createdAt
    } else if (counter++ < 100) {
      setTimeout(() => this.initSharedLists(counter), 10);
    }
  }

  sort(sortBy : string) : void {
  	if (sortBy !== this.sortBy) { // new sort term
  		this.sortBy = sortBy;
  		this.ascending = true;
  	} else
  		this.ascending = !this.ascending;

  	this.items = this.firebaseService.displayListsRecipes(this.isList, sortBy, this.ascending);
  }

  sharedSort(sortBy : string) : void {
    if (sortBy !== this.sharedSortBy) { // new sort term
      this.sharedSortBy = sortBy;
      this.sharedAscending = true;
    } else
      this.sharedAscending = !this.sharedAscending;

    this.sharedLists = this.firebaseService.displaySharedLists(sortBy, this.sharedAscending);
  }
}


// WEBPACK FOOTER //
// /Users/briznad/Documents/WebDev/personal/cartmigo/cartmigo-dev/src/app/components/manage-lists-recipes/manage-lists-recipes.ts